import Page from 'component/Page';
import Table from 'component/Table';
import { useCallback, useEffect, useState } from 'react';
import { Button, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { sendPost } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';

const ContractSelect = ({
  selectedContracts = [],
  onItemSelected = () => {},
  multiple = false,
  isChild = false,
  accountChildID,
}) => {
  const currentUser = useSelector(selectCurrentUser);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedItem, setSelectedItem] = useState([]);
  const [searchId, setSearchId] = useState('');

  // console.log(selectedItem);

  const mainActions = multiple
    ? [
        // () => (
        //   <span>
        //     {getString(string.ROW_SELECTED_COUNT, selectedItem.length)}
        //   </span>
        // ),
      ]
    : [];

  const title = string.SERVICE_ACCOUNT_SELECT;
  const headers = [string.LOGIN_ID, string.ACCOUNT_NAME];
  const [data, setData] = useState([]);
  const dataTable = useCallback(
    (responseData) =>
      responseData.map((raw, key) => ({
        key,
        data: [raw.loginId, raw.accountName],
        raw: { ...raw },
      })),
    []
  );
  const onSelect = (e) => {
    let { raw } = e;
    if (!multiple) {
      onItemSelected(raw);
      return;
    }
    let arr;
    let idx = -1;
    selectedItem?.forEach((item, index) => {
      if (item.accountId === raw.accountId) {
        idx = index;
        return;
      }
    });
    if (idx > -1) {
      let { [idx]: itm, ...rest } = selectedItem;
      arr = Object.values(rest);
    } else {
      arr = [raw];
    }
    // arr = [raw];
    setSelectedItem(arr);
  };

  const actions = [
    ({ raw }) => {
      let idx = -1;
      selectedItem?.forEach((item, index) => {
        if (item.accountId === raw.accountId) {
          idx = index;
          return;
        }
      });
      return selectedContracts.indexOf(raw?.accountId) > -1
        ? null
        : {
            render: idx > -1 ? 'selected' : 'select',
            // selectedItem?.indexOf(raw) > -1 ? 'selected' : 'select',
            onClick: onSelect,
          };
    },
  ];

  const doSearch = useCallback(
    (page, pageSize, searchId) =>
      sendPost({
        url: Urls.user.parentList,
        body: {
          offset: (page - 1) * pageSize,
          size: pageSize,
          keyword: searchId,
        },
      }).then((response) => {
        const { total, result } = response;

        setData(result);
        setTotal(total);
      }),
    [currentUser]
  );

  useEffect(() => {
    doSearch(page, pageSize, searchId);
  }, [page, pageSize, doSearch, searchId]);

  return (
    <>
      <Page
        title={title}
        body={
          <>
            <Container>
              <Table
                className="nowrap"
                mainActions={mainActions}
                page={page}
                pageSize={pageSize}
                total={total}
                onPageChanged={setPage}
                onPageSizeChanged={setPageSize}
                headers={headers}
                data={dataTable(data)}
                onRowClick={onSelect}
                actions={actions}
                search={true}
                onSearch={(value) => setSearchId(value)}
                placeHolder={string.ACCOUNT_NAME}
              />
              {multiple && (
                <Row className="form-button-row">
                  <Button
                    disabled={!selectedItem.length}
                    onClick={() => onItemSelected(selectedItem)}
                  >
                    {string.ITEM_SELECT}
                  </Button>
                </Row>
              )}
            </Container>
          </>
        }
      />
    </>
  );
};

export default ContractSelect;
